<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 282 301"
    preserveAspectRatio="xMidYMid meet"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M.726074 301 114.335 0h52.948l114.443 301h-47.945l-30.643-85.464H77.2298L45.9612 301H.726074ZM80.5651 176.556c-1.1118.834-1.6677 2.015-1.6677 3.544 0 1.528.4864 2.779 1.4592 3.752.9728.973 2.2931 1.459 3.9607 1.459 0 1.529.4864 2.849 1.4592 3.96 1.1118 1.112 2.3625 1.668 3.7522 1.668 1.5287 0 2.7795-.486 3.7523-1.459.9728-1.112 1.4592-2.501 1.4592-4.169v-6.045h91.3038v6.045c0 1.668.417 3.057 1.251 4.169.973.973 2.224 1.459 3.752 1.459 1.39 0 2.571-.556 3.544-1.668 1.112-1.111 1.668-2.431 1.668-3.96 1.667 0 2.988-.486 3.96-1.459 1.112-.973 1.668-2.224 1.668-3.752 0-1.39-.625-2.571-1.876-3.544-1.112-.973-2.641-1.459-4.586-1.459h-6.879L142.894 46.901l5.211-5.0028c1.112-1.1117 1.668-2.4319 1.668-3.9605 0-1.3897-.487-2.5709-1.459-3.5437-.973-.9727-2.224-1.4591-3.753-1.4591-1.389 0-2.64.5559-3.752 1.6676-1.112-1.1117-2.432-1.6676-3.961-1.6676-1.389 0-2.571.4864-3.543 1.4591-.973.9728-1.459 2.154-1.459 3.5437 0 1.5286.555 2.8488 1.667 3.9605l5.003 5.0028-46.4858 128.196h-6.8791c-1.8066 0-3.3353.486-4.586 1.459Z"
      fill="currentColor"
    />
  </svg>
</template>
